import React, { useState, useEffect } from "react";
import classes from "./preferenceselectiontile.module.scss";
import PreferenceSelectionPopup from "./PreferenceSelectionPopup";
import dateFormat from "dateformat";
import Cookie from "js-cookie";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { useNavigate } from "react-router-dom";
import { toUpperCaseString } from "../../Shared/Utill/Utills";
import { center, isEmpty } from "underscore";


const PreferenceSelectionTile = (props) => {       
const personDetails = useSelector((state) => state.person.personData);
const urlDetails = useSelector((state) => state.url.urlData);
const [showPreferenceBoxOpen,setShowPreferenceBox] = useState(false)
const [bowFullName,setBowFullName] = useState("")
const [eowFullName,setEowFullName] = useState("")
const [weeklyAvailability,setWeeklyAvailability] = useState()
const [nullTile,setNullTile] = useState(false);
const colleagueTKN = Cookie.get('X_TKN');
const fscData = props.fscData
console.log(JSON.stringify(props.weeklyData) + "WEEKLY INFOOO")
console.log(props.eow + " eow")
const options ={month: 'short'}
const bow = props.bow
const eow = props.eow
const history = useNavigate();

const weekBody = {
  "ascNbr": "10011802",
  "myDiv": "71",
  "myStore": "0693",
  "fscyyyy": 2022,
  "fscww": 40,
  "fscBow":"2022-11-06",
  "fscEow":"2022-11-12",
  "myDept": "406",
  "myWorkschedule": "MY_SEASONAL"
}

useEffect(() => {
  
  if((props.bow!== undefined) && (props.eow!==undefined)) {
    formatBow(props.bow)
    formatEow(props.eow)
  }

  if (props.weeklyData!=undefined) {
    console.log(props.weeklyData + " change conditional")
    showNullTile(props)
  }
  
 // getWeekInfo()
}, [props.bow,props.eow,props.weeklyData]);


const showNullTile = (props) => {
  console.log("Checking if we should show Null Case")
  let valuesAreNull = 
  (props.weeklyData.avlPWH_nbr_days_min === undefined || props.weeklyData.avlPWH_nbr_days_min===null) && 
  (props.weeklyData.avlPWH_wkly_hrs_min === undefined || props.weeklyData.avlPWH_wkly_hrs_min===null) && 
  (props.weeklyData.avlPWH_shift_len_min === undefined || props.weeklyData.avlPWH_shift_len_min===null)
  console.log("The null boolean value is :D " + valuesAreNull)
  if (valuesAreNull) {
    console.log("Checking if we should show base case")
    setNullTile(true)
  }
}

const onUpdateAvailabilitySuccess = (severity) => {
  setShowPreferenceBox(false);
  props.showSuccessMessage(severity,"Weekly PWH Saved Successfully");
};

const getWeekInfo = () => {
  console.log("SUPPPPPPPPPPP")
  axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_BASE_PAGE_DATA}`, weekBody , {
    headers: {
      'content-type': 'application/json',
      'Authorization':'Bearer ' + colleagueTKN
    }
  }).then((response) => {
   //TODO: uncomment below line and comment above to run locally 
    
    console.log("-----event", response.data.wklyData)
    setWeeklyAvailability(response.data.wklyData)
    
  })
  .catch((error) => {
    if(error.message === 'Network Error') {
      history("/somethingwentwrong", {state:`Please logout and try again `})
    }else {
      history("/somethingwentwrong", {state:`${constants.WFM_GET_BASE_PAGE_DATA}...failed`})
      }
  });
}

const formatMonth = (input) => 
  {
    const d = new Date(input)
    const s = d.toLocaleDateString('en-US', options)
    console.log(s + "-------")
    return s
  }

  const formatDate = (input) => 
  {
    console.log(new Date(input).getUTCDate() + "-------")
    return new Date(input).getUTCDate()
  }

const formatBow = (bow) => {
  let bowDate = new Date(bow) 
  let bowFullName = dateFormat(bowDate,"dddd")
  console.log("full date for bow: " + bowFullName)
  return bowFullName;
  }

const formatEow = (eow) => {
  let eowDate = new Date(eow)
  let eowFullName = dateFormat(eowDate,"dddd")
  console.log("full date for eow: " + eowFullName)
  return eowFullName;
}

const handleCellClick = () => {
  //console.log(eventDay);
  
  //setPopupData(eventDay);
  setShowPreferenceBox(true);
  
}

const PreferencePopupClose = () => {
  setShowPreferenceBox(false);
}

// select preference link disable code
const nbrDaysDropDown = (element) => {
  let dropDownValue;
  if (element.ctlName.indexOf("ddnbrdays") > -1) {
    if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
      console.log("we are MISSING SOMETHING")
      return null;
    } else {
      dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
      return dropDownValue
    }
  }
 }


 const wklyHrsDropDown = (element) => {
  let dropDownValue;
  if (element.ctlName.indexOf("ddwklyrs") > -1) {
    if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
      console.log("we are MISSING SOMETHING")
      return null;
    } else {
      dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
      return dropDownValue
    }
  }
 }


 const shiftHrsDropDown = (element) => {
  let dropDownValue;
  if (element.ctlName.indexOf("ddshifthrs") > -1) {
    if ( (element.ctlValue01 === "") || (element.ctlValue02 === "")  ) {
      console.log("we are MISSING SOMETHING")
      return null;
    } else {
      dropDownValue = element.ctlValue01 + " - " + element.ctlValue02
      return dropDownValue
    }
  }
 }
// select preference link disable code ends


  if (!nullTile) {
    return (
      <div>
        <div className={`${classes.tile} ${classes.preferred}`}>
              <div className={classes.tilehead}>
               <div className={classes.setitle}>
                  <h6><b>Preferences</b></h6>
                </div>
                <div className={classes.setitle}>
                   <div className={classes.setitle}>For week selected from  
                   {" "+formatMonth(props.bow)+" "+formatDate(props.bow) + " - " + formatMonth(props.eow) +" "+ formatDate(props.eow) }</div>
                </div>
              </div>
              <div className={classes.tilebottom}>
                <div className={classes.flexboxcontainer}>
                
                    <div >
                        <div className={classes.setsubtitle}>No Of Days</div>
                        {props.weeklyData && <div className={classes.sedescription}>{props.weeklyData.avlPWH_nbr_days_min} - {props.weeklyData.avlPWH_nbr_days_max}</div>}
                      </div>  
                    <div >
                        <div className={classes.setsubtitle}>Total Weekly Hours</div>
                        {props.weeklyData &&  <div className={classes.sedescription}>{props.weeklyData.avlPWH_wkly_hrs_min} - {props.weeklyData.avlPWH_wkly_hrs_max}</div>} 
                    </div>
                    <div>
                        <div className={classes.setsubtitle}>Daily Shift Length Hours</div>
                        {props.weeklyData && <div className={classes.sedescription}>{props.weeklyData.avlPWH_shift_len_min} - {props.weeklyData.avlPWH_shift_len_max}</div>}   
                      </div>
                  </div>
                  <div >
                  {toUpperCaseString(props.ruleData.preferences_editable) !== "Y" ? ( 
                        <span className={classes.setitle}
                        style={{ textDecoration: "underline" , color: "gray"}}
                          >
                        Edit
                        </span>
                        ):
                      <div>
                          <span className={classes.setitle}
                          style={{ textDecoration: "underline", cursor: "pointer" }}
                          onClick= {event => handleCellClick()}
                            >
                          Edit
                          </span>
                      </div> }
                      
                  </div>
                </div> 
              <div> {showPreferenceBoxOpen && props.weeklyData && props.fscData &&  (<PreferenceSelectionPopup ruleData = {props.ruleData} appControls = {props.appControls}  weeklyData = {props.weeklyData} fscData = {props.fscData} 
              successOnUpdate = {onUpdateAvailabilitySuccess} PreferencePopupClose={PreferencePopupClose} bow ={props.bow} eow = {props.eow} />) }</div>
            
        </div>
    
      </div>);
  } else {
    
    let dropdown_1 =  props.appControls.map(e => nbrDaysDropDown(e))
    let dropdown_2 =  props.appControls.map(e => wklyHrsDropDown(e))
    let dropdown_3 =  props.appControls.map(e => shiftHrsDropDown(e))
    let isDisableLink = false;
     
     dropdown_1 = dropdown_1.filter(e => {return e != null && e!= ''});
     dropdown_2 = dropdown_2.filter(e => {return e != null && e!= ''});
     dropdown_3 = dropdown_3.filter(e => {return e != null && e!= ''});

     if(isEmpty(dropdown_1) && isEmpty(dropdown_2) && isEmpty(dropdown_3) ){
        isDisableLink = true;
     }
    
    return (
        <div>
          <div className={`${classes.tile} ${classes.preferred}`}>
                <div className={classes.tilehead}>
                 <div className={classes.setitle}>
                    <h6><b>Preferences</b></h6>
                  </div>
                  <div className={classes.setitle}>
                     <div className={classes.setitle}>For week selected from  
                     {" "+formatMonth(props.bow)+" "+formatDate(props.bow) + " - " + formatMonth(props.eow) +" "+ formatDate(props.eow) }</div>
                  </div>
                </div>
                  <div>
                  <div className={classes.tilebottom}>
                    <div className={classes.flexboxcontainer2}>
                      <div >
                      {toUpperCaseString(props.ruleData.preferences_editable) === "Y" && !isDisableLink ? ( 
                          <span className={classes.setitle}
                          style={{ textDecoration: "underline", cursor: "pointer", fontSize: "14px !important", padding: "20px 70px 20px 70px " , alignItems: 'center'}}
                          onClick= {event => handleCellClick()}
                            >
                            Select Preferences
                          </span> 
                      ): 
                        <div>
                        <span className={classes.setitle}
                          style={{ color:"gray", textDecoration: "underline", fontSize: "14px !important", padding: "20px 40px 20px 40px " , alignItems: 'center'}}
                            >
                            Select Preferences
                          </span> 
                        </div>
                      }
                      </div>
                    </div>
                  </div>
                  </div>
                
                <div> {showPreferenceBoxOpen && props.weeklyData && props.fscData &&  (<PreferenceSelectionPopup ruleData = {props.ruleData} appControls = {props.appControls}  weeklyData = {props.weeklyData} fscData = {props.fscData} 
               successOnUpdate = {onUpdateAvailabilitySuccess} PreferencePopupClose={PreferencePopupClose} bow ={props.bow} eow = {props.eow} />) }</div>
              
          </div>
      
        </div>);
    
  }

   
}

export default PreferenceSelectionTile;